module.exports = __webpack_public_path__ + "img/storage-3.e4c9dc19.jpg";